"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHexString = exports.createPassword = void 0;
const _passChr = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'm', 'n', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 1, 2, 3, 4, 5, 6, 7, 8, 9];
function rndChr(x, y, z) { let num; const work = true; do {
    num = Math.round((Math.random() * z));
    if (num >= x && num <= y)
        break;
} while (work); return (num); }
function createPassword(size = 8) { let pass = ''; for (let i = 0; i < size; i++)
    pass += _passChr[rndChr(0, 32, 100)]; return pass; }
exports.createPassword = createPassword;
function createHexString(size = 32) {
    let hex = '';
    for (let i = 0; i < size; i++) {
        const int = Math.floor(Math.random() * 16);
        hex += int.toString(16);
    }
    return hex;
}
exports.createHexString = createHexString;
//# sourceMappingURL=generators.js.map